// authContext.js
import React, { useContext, useState, useEffect } from "react";
import { initFirebase, getFirebase } from "../../firebase/firebase";

const AuthContext = React.createContext(undefined);

export function useAuth() {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [userLoggedIn, setUserLoggedIn] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const initAuth = async () => {
        await initFirebase();
        const { auth } = getFirebase();
        if (auth) {
          const { onAuthStateChanged } = await import("firebase/auth");
          const unsubscribe = onAuthStateChanged(auth, (user) => {
            if (user) {
              setCurrentUser(user);
              setUserLoggedIn(true);
            } else {
              setCurrentUser(null);
              setUserLoggedIn(false);
            }
            setLoading(false);
          });

          return () => unsubscribe();
        }
        setLoading(false);
      };

      initAuth();
    } else {
      setLoading(false);
    }
  }, []);

  const value = {
    currentUser,
    setCurrentUser,
    userLoggedIn,
    setUserLoggedIn,
    loading,
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}

